import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
function HomeSettings() {
  const [hero, setHero] = useState({
    announcement: "",
    students: "",
    courses: "",
    placement: "",
    description: "",
  });

  const [course, setCourse] = useState({
    id: null,
    title: "",
    tag: "",
    meta: "",
    progress: "",
    icon: "",
    color: "",
  });

  const [courses, setCourses] = useState([]);

  useEffect(() => {
    loadHero();
    loadCourses();
  }, []);

  const loadHero = async () => {
    try {
      const res = await fetch("https://swiftintelli.com/api/getHome.php");

      if (!res.ok) {
        throw new Error("Server error");
      }

      const data = await res.json();
      setHero(data);
    } catch (err) {
      console.error("Hero fetch error:", err);
      Swal.fire({
  icon: "error",
  title: "Load Failed",
  text: "Failed to load hero data",
});
    }
  };

  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (!user || user.role !== "admin") {
      navigate("/"); // 🚫 non-admin cannot access
    }
  }, []);

  const loadCourses = async () => {
    try {
      const res = await fetch(
        "https://swiftintelli.com/api/getHeroCourses.php",
      );

      if (!res.ok) {
        throw new Error("Server error");
      }

      const data = await res.json();
      setCourses(data);
    } catch (err) {
      console.error("Courses fetch error:", err);
      Swal.fire({
  icon: "error",
  title: "Load Failed",
  text: "Failed to load courses",
});
    }
  };

  const handleHeroChange = (e) => {
    setHero({ ...hero, [e.target.name]: e.target.value });
  };

  const handleCourseChange = (e) => {
    setCourse({ ...course, [e.target.name]: e.target.value });
  };

  const saveHero = async () => {
    try {
      const res = await fetch("https://swiftintelli.com/api/updateHome.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(hero),
      });

      if (!res.ok) {
        throw new Error("Server error");
      }

      const data = await res.json();
      console.log(data);

      Swal.fire({
  icon: "success",
  title: "Updated",
  text: "Hero section updated successfully",
  timer: 1800,
  showConfirmButton: false,
});
    } catch (err) {
      console.error(err);
     Swal.fire({
  icon: "error",
  title: "Update Failed",
  text: "Failed to update hero section",
});
    }
  };

  const saveCourse = async () => {
    const url = course.id
      ? "https://swiftintelli.com/api/updateHeroCourse.php"
      : "https://swiftintelli.com/api/addHeroCourse.php";

    await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(course),
    });

    Swal.fire({
  icon: "success",
  title: course.id ? "Updated" : "Added",
  text: course.id
    ? "Course updated successfully"
    : "Course added successfully",
  timer: 1800,
  showConfirmButton: false,
});

    setCourse({
      id: null,
      title: "",
      tag: "",
      meta: "",
      progress: "",
      icon: "",
      color: "",
    });

    loadCourses();
  };

  const editCourse = (c) => {
    setCourse(c);
  };

 const deleteCourse = async (id) => {
  const result = await Swal.fire({
    title: "Delete Course?",
    text: "This action cannot be undone",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#dc2626",
    cancelButtonColor: "#6b7280",
    confirmButtonText: "Yes, Delete",
  });

  if (!result.isConfirmed) return;

  await fetch("https://swiftintelli.com/api/deleteHeroCourse.php", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id }),
  });

  Swal.fire({
    icon: "success",
    title: "Deleted",
    text: "Course deleted successfully",
    timer: 1500,
    showConfirmButton: false,
  });

  loadCourses();
};

  return (
    <div className="hs-page">
      <h2 className="hs-page-title">Home Page Settings</h2>

      {/* HERO */}
      <div className="hs-card">
        <div className="hs-card-header">
          <div className="hs-icon-box blue">🏠</div>
          <div>
            <p className="hs-card-title">Hero Section</p>
            <p className="hs-card-sub">Update homepage stats</p>
          </div>
        </div>

        <div className="hs-divider" />

        <div className="hs-grid">
          <div className="hs-field hs-full">
            <label className="hs-label">Announcement</label>
            <input
              className="hs-input"
              name="announcement"
              value={hero.announcement}
              onChange={handleHeroChange}
            />
          </div>

          <div className="hs-field hs-full">
            <label className="hs-label">Description</label>
            <textarea
              className="hs-input"
              name="description"
              value={hero.description}
              onChange={handleHeroChange}
            />
          </div>

          <div className="hs-field">
            <label className="hs-label">Students</label>
            <input
              className="hs-input"
              name="students"
              value={hero.students}
              onChange={handleHeroChange}
            />
          </div>

          <div className="hs-field">
            <label className="hs-label">Courses</label>
            <input
              className="hs-input"
              name="courses"
              value={hero.courses}
              onChange={handleHeroChange}
            />
          </div>

          <div className="hs-field">
            <label className="hs-label">Placement %</label>
            <input
              className="hs-input"
              name="placement"
              value={hero.placement}
              onChange={handleHeroChange}
            />
          </div>
        </div>

        <div className="hs-card-footer">
          <button className="hs-btn hs-btn-blue" onClick={saveHero}>
            Update Hero
          </button>
        </div>
      </div>

      {/* COURSE FORM */}
      <div className="hs-card">
        <div className="hs-card-header">
          <div className="hs-icon-box green">📦</div>
          <div>
            <p className="hs-card-title">Hero Course Card</p>
            <p className="hs-card-sub">Add / Edit Course</p>
          </div>
        </div>

        <div className="hs-divider" />

        <div className="hs-grid">
          <div className="hs-field">
            <label className="hs-label">Title</label>
            <input
              className="hs-input"
              name="title"
              value={course.title}
              onChange={handleCourseChange}
            />
          </div>

          <div className="hs-field">
            <label className="hs-label">Tag</label>
            <input
              className="hs-input"
              name="tag"
              value={course.tag}
              onChange={handleCourseChange}
            />
          </div>

          <div className="hs-field">
            <label className="hs-label">Meta</label>
            <input
              className="hs-input"
              name="meta"
              value={course.meta}
              onChange={handleCourseChange}
            />
          </div>

          <div className="hs-field">
            <label className="hs-label">Icon</label>
            <input
              className="hs-input"
              name="icon"
              value={course.icon}
              onChange={handleCourseChange}
            />
          </div>

          {/* PROGRESS */}
          <div className="hs-field hs-full">
            <label className="hs-label">Progress</label>

            <div className="hs-prog-wrap">
              <input
                className="hs-input hs-prog-inp"
                name="progress"
                value={course.progress}
                onChange={handleCourseChange}
              />

              <div className="hs-prog-track">
                <div
                  className="hs-prog-fill"
                  style={{ width: (course.progress || 0) + "%" }}
                />
              </div>

              <span className="hs-prog-label">{course.progress || 0}%</span>
            </div>
          </div>

          {/* COLOR */}
          <div className="hs-field hs-full">
            <label className="hs-label">Color</label>

            <div className="hs-color-wrap">
              <input
                className="hs-input"
                name="color"
                value={course.color}
                onChange={handleCourseChange}
              />

              <div
                className="hs-color-swatch"
                style={{ background: course.color || "#ccc" }}
              />
            </div>
          </div>
        </div>

        <div className="hs-card-footer">
          <button className="hs-btn hs-btn-green" onClick={saveCourse}>
            {course.id ? "Update Course" : "Add Course"}
          </button>
        </div>
      </div>

      {/* COURSE LIST */}
      <div className="hs-card">
        <div className="hs-card-header">
          <div className="hs-icon-box green">📋</div>
          <div>
            <p className="hs-card-title">Course List</p>
          </div>
        </div>

        <div className="hs-divider" />

        <div style={{ padding: "16px" }}>
          {courses.map((c) => (
            <div
              key={c.id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "10px",
                padding: "10px",
                border: "1px solid #eee",
                borderRadius: "8px",
              }}
            >
              <div>
                <b>{c.title}</b> ({c.tag})
              </div>

              <div style={{ display: "flex", gap: "10px" }}>
                <button
                  className="hs-btn hs-btn-blue"
                  onClick={() => editCourse(c)}
                >
                  Edit
                </button>

                <button
                  className="hs-btn"
                  style={{ background: "#dc2626", color: "#fff" }}
                  onClick={() => deleteCourse(c.id)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default HomeSettings;
